module.exports = __webpack_public_path__ + "static/footer-bg-42cb28ef5a913d09120a76cf110b6403.svg";